"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineMemberPermissionEdit = exports.MemberPermissionEdit = void 0;
const apis_1 = require("./apis");
const lib_es2015_1 = require("@hodol/web-component-helper/lib-es2015");
const lib_es2015_2 = require("@hodol/complex-inputs/lib-es2015");
const lib_es2015_3 = require("@hodol/dom-helper/lib-es2015");
const Constants = require("./constants");
const apis_2 = require("../oauth-client/apis");
const OauthClient = require("../oauth-client/entity");
const apis_3 = require("../member-group/apis");
class MemberPermissionEdit extends HTMLElement {
    constructor() {
        super();
        this.memberPermissionPK = Number((0, lib_es2015_3.getAttributeOrThrowError)(this, 'member-permission-pk'));
        this.apis = new apis_1.default();
        this.router = (0, lib_es2015_1.useRouter)();
        this.oauthClientApis = new apis_2.default();
        this.memberGroupApis = new apis_3.default();
        this.style.setProperty('display', 'block');
    }
    connectedCallback() {
        return __awaiter(this, void 0, void 0, function* () {
            this.innerHTML = 'Loading data ...';
            const entity = yield this.apis.getByPK({ pk: this.memberPermissionPK }, ['oauth_client']);
            if (entity === null) {
                alert('fail to load tenant data.');
                return;
            }
            this.innerHTML = `
    <div class="edit-form">
      <div class="edit-form-field-name">pk</div>
      <div>${entity.pk}</div>
      
      <div class="edit-form-field-name">Oauth Client Id</div>
      <div>${entity.oauth_client.id} (${entity.oauth_client_pk})</div>
      
      <div class="edit-form-field-name">Member Group</div>
      <div><search-selector class="member-group-pk"></search-selector></div>
      
      <div class="edit-form-field-name">Kind</div>
      <div><input class="kind" /></div>
      
      <div class="edit-form-field-name">Resource</div>
      <div><input class="resource" /></div>
      
      <div class="edit-form-field-name">Is Allowed</div>
      <div>
        <select class="is-allowed">
          <option value="true">allowed</option>
          <option value="false">denied</option>
        </select>
      </div>
      
      <div class="edit-form-footer"><button class="submit-btn">Submit</button></div>
    </div>`;
            this.memberGroupPKSearchSelector = (0, lib_es2015_3.getQuerySelectOrThrowError)(this, 'search-selector.member-group-pk');
            this.memberGroupPKSearchSelector.init({ value: `${entity.member_group_pk}`, displayText: entity.member_group_name, description: '' }, this.memberGroupApis.getListApiForMemberGroupSearchSelectorByOauthClientPK(`${entity.oauth_client_pk}`));
            this.kindInput = (0, lib_es2015_3.getQuerySelectOrThrowError)(this, 'input.kind');
            this.kindInput.value = entity.kind;
            this.resourceInput = (0, lib_es2015_3.getQuerySelectOrThrowError)(this, 'input.resource');
            this.resourceInput.value = entity.resource;
            this.isAllowedSelect = (0, lib_es2015_3.getQuerySelectOrThrowError)(this, 'select.is-allowed');
            this.isAllowedSelect.value = entity.is_allowed ? 'true' : 'false';
            (0, lib_es2015_3.getQuerySelectOrThrowError)(this, 'button.submit-btn').addEventListener('click', () => {
                if (this.kindInput.value === '') {
                    alert(`put ${Constants.subjectName} kind`);
                    return;
                }
                void (() => __awaiter(this, void 0, void 0, function* () {
                    const ans = confirm(`Are you sure to update ${Constants.subjectName} info?`);
                    if (!ans)
                        return;
                    const apiResp = yield this.apis.update({
                        pk: entity.pk,
                        oauth_client_pk: entity.oauth_client_pk,
                        member_group_pk: Number(this.memberGroupPKSearchSelector.value),
                        kind: this.kindInput.value,
                        resource: this.resourceInput.value,
                        is_allowed: this.isAllowedSelect.value === 'true',
                        oauth_client: OauthClient.newEntity(),
                        member_group_name: '',
                    });
                    if (apiResp === null) {
                        return;
                    }
                    alert(`updated ${Constants.subjectName}, successfully!`);
                    this.router.push(`/web/${Constants.routerPathGroup}/list?page_no=1&page_size=10&query=&oauth_client_pk=`);
                }))();
            });
        });
    }
}
exports.MemberPermissionEdit = MemberPermissionEdit;
const defineMemberPermissionEdit = (name) => {
    (0, lib_es2015_2.defineSearchSelector)('search-selector');
    (0, lib_es2015_1.defineIfUndefined)(name, MemberPermissionEdit);
};
exports.defineMemberPermissionEdit = defineMemberPermissionEdit;
